module.exports = __webpack_public_path__ + "static/media/mentalWellness.bf68cf77.webp";